import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Table, Tabs, Tooltip, message } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../utils/eventEmitter';
import useBudgetsAPI from '../apis/budgetsAPI';
import BudgetTable from '../components/BudgetTable';
import dayjs from 'dayjs';



const columns = [
  {
    title: 'Budgetary Positon',
    dataIndex: 'position_id',
    key: 'position_id',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
    key: 'start_date',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
    key: 'end_date',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true
  },
  {
    title: 'Planned Amount',
    dataIndex: 'planned_amount',
    key: 'planned_amount',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true
  },
  {
    title: 'Practical Amount',
    dataIndex: 'practical_amount',
    key: 'practical_amount',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true
  },
  {
    title: 'Theoretical Amount',
    dataIndex: 'theoretical_amount',
    key: 'theoretical_amount',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
  },
  {
    title: 'Achievement',
    dataIndex: 'achievement',
    key: 'achievement',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
];



const Cell = ({editable, record, inputNode, dataIndex, children, editing, ...restProps}) => {
  console.log(record)
  return (
    <td {...restProps} onClick={()=> alert('clicked me', editable, dataIndex)} >
      {
        editing === 'EDIT' ? (
        <Form.Item name={dataIndex} className='m-0' >
          {inputNode === 'select' ?
            <Select options={[]} />:
            inputNode === 'datepicker' ?
            <DatePicker mode='date'/> :
            inputNode === 'number' ?
            <InputNumber /> :
            <Input />
          }
        </Form.Item>) : 
        (children )
      }
    </td>
  )
}


const BudgetChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const {budget, positions } = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const { save, update, processBudget } = useBudgetsAPI();
  const [name, setName] = useState(budget.name ? budget.name : '');
  const [status, setStatus] = useState(budget.status ? budget.status : '');
  const [budgetLines, setBudgetLines] = useState(budget.budget_lines ? budget.budget_lines : []);
  const [date, setDate] = useState();

  const onChangeName = e => setName(e.target.value);
  const onChangeDate = e => setDate(e);

  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    data['start_date'] = new Date(data.period[0]).toLocaleDateString();
    data['end_date'] = new Date(data.period[1]).toLocaleDateString();
    budgetLines.forEach((item, idx) => {
      budgetLines[idx]['start_date'] = new Date(budgetLines[idx]['start_date']).toLocaleDateString();
      budgetLines[idx]['end_date'] = new Date(budgetLines[idx]['end_date']).toLocaleDateString();
    });
    data['budget_lines'] = budgetLines;
    delete data.period;
    save(data, success);
  }

  const handleConfirm = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    data['start_date'] = new Date(data.period[0]).toLocaleDateString();
    data['end_date'] = new Date(data.period[1]).toLocaleDateString();
    data['status'] = 'confirmed';
    budgetLines.forEach((item, idx) => {
      budgetLines[idx]['start_date'] = new Date(budgetLines[idx]['start_date']).toLocaleDateString();
      budgetLines[idx]['end_date'] = new Date(budgetLines[idx]['end_date']).toLocaleDateString();
    });
    data['budget_lines'] = budgetLines;
    delete data.period;
    update(budget.seo, data, success);
  }

  const handleProcessBudget = (status) => {
    processBudget(budget.seo, {status: status}, success);
  }


  useEffect(() => {
    EventEmitter.subscribe('budget_response', data => {
      navigate('/accounting/budgets/'+data);
      setStatus('confirmed');
    });

    EventEmitter.subscribe('budget_status', data => {
      setStatus(data);
    });
    return () => {
      EventEmitter.unsubscribe('budget_response');
      EventEmitter.unsubscribe('budget_status');
    }
  },[]);

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/accounting/budgets'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Budgets</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ status ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        
        <div className='flex justify-between'>
          {status === 'draft' && <Button onClick={handleConfirm}>CONFIRM</Button>}
          {status === 'confirmed' && <Button onClick={()=> handleProcessBudget('validated')}>APPROVE</Button>}
          {status === 'validated' && <Button onClick={()=> handleProcessBudget('done')}>DONE</Button>}
          {status === 'done' && <div></div>}
          {(status === 'draft' || status==='confirmed' || status ==='validated' || status === 'done' || status==='cancel') && (
            <div id='status-container '>
              <ul className='inner-wrapper'>
                <li className={
                    status === 'draft'
                      ? 'draft-disabled first draft draft-status'
                      : 'first draft-status draft-transparent'
                  }> DRAFT</li>
                <li className = {status === 'cancel' ? 'middle middle-status' : 'middle-status middle-transparent'}>CANCELLED</li>
                <li className = {status === 'confirmed' ? 'middle middle-status' : 'middle-status middle-transparent'}>CONFIRMED</li>
                <li className = {status === 'validated' ? 'middle middle-status' : 'middle-status middle-transparent'}>VALIDATED</li>
                <li className={
                    status === 'done'
                      ? 'posted posted-status'
                      : 'posted-status posted-transparent'
                  }
                >
                  DONE
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      <div className='mt-5 bg-white p-3'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Budget Name" 
          value={name} 
          onChange={onChangeName}
          style={{maxWidth: '500px'}}
          disabled={status==='draft' ? false : true}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 7}}
          initialValues={budget.seo ? {
            responsible: budget.responsible, 
            period: [dayjs(budget.start_date, 'YYYY-MM-DD'), dayjs(budget.end_date, 'YYYY-MM-DD')]
          }: {}}
          disabled={status==='draft' ? false : true}
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Responsible' name={'responsible'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
            </Col>
            <Col md={{span: 11}}>
              <Form.Item label='Period' name={'period'} className='font-semibold text-gray-800 mb-2 column' required>
                <DatePicker.RangePicker className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' onChange={onChangeDate}/>
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type="card"
            items={[
              {
                key: '1',
                label: 'Budget Lines',
                children: 
                  <BudgetTable 
                    dataSource={budgetLines}
                    setEntries={setBudgetLines}
                    columns={columns}
                    positions={positions}
                    status={status}
                    period = {form.getFieldValue('period') === undefined ? [] : form.getFieldValue('period')}
                  />
                  // <>
                  //   <Table 
                  //     sticky
                  //     columns={mergedColumns}
                  //     dataSource={budgetLines}
                  //     scroll={{ y: 400,}}
                  //     pagination={false}
                  //     rowKey={'code'}
                  //     rowClassName="editable-row"
                  //     components={{
                  //       body: {cell: ({editable, record, colId, inputNode, dataIndex, children, editing, ...restProps}) => {
                  //         // console.log(dataIndex)
                  //         return (
                  //           <>
                  //           {
                  //             isEditing === dataIndex ? 
                  //               <td {...restProps} onClick={()=> setIsEditing('')}>
                  //                 <Form.Item name={dataIndex} className='m-0'>
                  //                   {inputNode === 'select' ?
                  //                     <Select options={[]} autoFocus onClick={e => e.stopPropagation()}/>:
                  //                     inputNode === 'datepicker' ?
                  //                     <DatePicker mode='date' autoFocus onClick={e => e.stopPropagation()}/> :
                  //                     inputNode === 'number' ?
                  //                     <InputNumber autoFocus onClick={e => e.stopPropagation()}/> :
                  //                     <Input autoFocus onClick={e => e.stopPropagation()} />
                  //                   }
                  //                 </Form.Item>
                  //               </td> : 
                  //               <td {...restProps} onClick={()=>handleEditing(dataIndex)}>{inputNode === 'datepicker' ?  form.getFieldValue(dataIndex) !== undefined && new Date(form.getFieldValue(dataIndex).$d).toLocaleDateString(): form.getFieldValue(dataIndex)}</td>
                  //             }
                  //           </>
                  //         )
                  //       }}
                  //     }}
                  //   />
                  //   <Button onClick={addLine}>Add Entry</Button>
                  // </>
              },
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default BudgetChanges;